import React from 'react'
import { componentForName } from './ComponentTypes'

const DynamicComponent = ({ item, children }) => {
  const name = item.component_name

  const SpecificComponent = componentForName(name)

  if ( ! SpecificComponent ) {
    return (
      <>
        <p className='text-danger'>
          DynamicComponent <code>{ name } </code> not implemented yet
        </p>
      </>
    )

  } else {
    return (
      <SpecificComponent {...item}>
        {children}
      </SpecificComponent>
    )
  }
}

export default DynamicComponent
